export default __webpack_public_path__ + "static/media/logo.a029ffe5.png";